import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
    CardDescription,
} from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import config from "../lib/config";
import axios from "../axios";

export default function AuthPage() {
    const [formData, setFormData] = useState({ email: "", password: "" })

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        const role = localStorage.getItem("role");
        if (token) navigate("/admin/dashboard");
    }, []);


    const darkBg = "bg-[#18181b]";
    const cardRadius = "rounded-[20px]";
    const inputBg = "bg-[#232325]";
    const inputBorder = "border border-[#39393b]";
    const inputRadius = "rounded-[10px]";


    async function signInUser(e) {
        e.preventDefault();
        setError("");

        setLoading(true);
        try {
            const res = await axios.post(`/login`, formData);
            setLoading(false);
            if ( res.data.token ) {
                localStorage.setItem("token", res.data.token);
                return window.location.replace("/admin/dashboard");
            }

            throw new Error("Signin failed. Server error.");
        } catch (err) {
            console.error("error:", err)
            setLoading(false);
            return setError("Signin failed. Server error." + err);
        }
    }

    return (
        <div className="min-h-screen flex flex-col items-center justify-center px-2">

            <div className="w-full flex justify-center">
                <Card
                    className={`${darkBg} ${cardRadius} border border-[#39393b] shadow-none w-[350px] max-w-[420px] relative overflow-hidden`}
                    style={{ zIndex: 1 }}
                >
                    <CardHeader className="pb-2 relative z-10">
                        <CardTitle className="text-white text-[1.4rem] font-bold">
                            Admin Login
                        </CardTitle>
                    </CardHeader>

                    <CardContent className="gap-6 flex flex-col relative z-10">
                        {error && (
                            <div className="text-red-500 text-center text-sm mb-2">
                                {error}
                            </div>
                        )}

                        <form onSubmit={signInUser} className="flex flex-col gap-6">
                            <div className="flex flex-col gap-2 mt-2">
                                <Label
                                    htmlFor="signin-email"
                                    className="text-white text-base font-semibold"
                                >
                                    Email
                                </Label>
                                <Input
                                    id="signin-email"
                                    type="email"
                                    autoComplete="email"
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value})}
                                    className={`${inputBg} ${inputBorder} ${inputRadius} text-white text-base py-3 px-4`}
                                />
                            </div>
                            <div className="flex flex-col gap-2">
                                <Label
                                    htmlFor="signin-password"
                                    className="text-white text-base font-semibold"
                                >
                                    Password
                                </Label>
                                <Input
                                    id="signin-password"
                                    type="password"
                                    autoComplete="current-password"
                                    onChange={(e) => setFormData({ ...formData, password: e.target.value})}
                                    className={`${inputBg} ${inputBorder} ${inputRadius} text-white text-base py-3 px-4`}
                                />
                            </div>
                            <Button
                                type="submit"
                                className="bg-white text-black text-[1.09rem] font-medium px-7 py-2 rounded-[10px] shadow-none hover:bg-[#ededed] transition-all duration-150"
                                style={{ boxShadow: "none" }}
                                disabled={loading}
                            >
                                {loading ? "Signing In..." : "Sign In"}
                            </Button>
                        </form>

                    </CardContent>

                </Card>
            </div>
        </div>
    );
}
